export enum PersonRole {
	COMPANY = 1,
	INDIVIDUAL = 0,
}
